// ============= Imports =============
import {
  FetchDataProps,
  ApiResponse,
  Client,
  PaginatedItems,
} from '../../../components/container/forms/types/api/graph.types';
import { tokenManager } from '@tw/tw-component-library';

// ============= Constants =============
const BASE_URL = import.meta.env.VITE_BASE_URL;
const API_ENDPOINT = '/api/Aderant/clients';
const AXIS_SCOPE = 'api://f23d5e95-70a8-4aca-b373-e23d8c9f6454/access_as_user';

const HEADERS = {};

// ============= Types =============

// ============= Utility Functions =============
/**
 * Constructs filter parameters for API query
 * @param searchValue Search term to filter users
 * @returns Formatted filter string
 */
// const constructFilterParams = (searchValue: string): string => {
//   return [
//     `startswith(givenName,'${searchValue}')`,
//     `startswith(surname,'${searchValue}')`,
//     `startswith(userPrincipalName,'${searchValue}')`,
//   ].join(' or ');
// };

/**
 * Creates headers for API request
 * @param token Authentication token
 * @returns Headers object
 */
const createHeaders = (token: string) => ({
  Authorization: `Bearer ${token}`,
  ...HEADERS,
});

// ============= Main Function =============
/**
 * Fetches users from Microsoft API based on search criteria
 * @param getAccessToken Function to acquire access token
 * @param searchValue Search string to filter users
 * @returns Promise with API response containing user data or error
 */
export const fetchClients = async ({
  getAccessToken,
  searchValue,
  office,
}: FetchDataProps): Promise<ApiResponse<PaginatedItems<Client>>> => {
  try {
    console.log('🔄 Fetching API data...');

    // Token acquisition with required scopes

    const token = await getAccessToken([AXIS_SCOPE]);
    if (!token) {
      throw new Error('Failed to acquire API token');
    }
    tokenManager.logTokenInfo(token, 'API');

    // URL construction
    const url = `${BASE_URL}${API_ENDPOINT}?searchTerm=${searchValue}&office=${office}`;
    const convertURI = encodeURI(url);
    console.log('🌐 Making request to:', convertURI);

    // API request
    const response = await fetch(convertURI, {
      method: 'GET',
      headers: createHeaders(token),
    });
    // Response handling
    if (!response.ok) {
      console.log(`HTTP error! status: ${response.status}`);
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    if (response.status === 204) {
      console.log('✅ API returned 204 No Content');
      return {
        success: true,
        data: { items: [] },
      };
    }

    const data = await response.json();
    console.log(`✅ API data fetched successfully: ${data}`);

    return {
      success: true,
      data: { items: data?.items ?? [] },
    };
  } catch (error) {
    console.error('🔴 Error fetching API data:', error);
    return {
      success: false,
      error:
        error instanceof Error ? error.message : 'An unknown error occurred',
    };
  }
};
